import FormattedHTMLMessage from 'I18n/components/FormattedHTMLMessage';
import { jsx as _jsx } from "react/jsx-runtime";
export function IntroStep({
  type,
  appName,
  introScreen
}) {
  const IntroComponent = introScreen !== null && introScreen !== void 0 ? introScreen : null;
  if (IntroComponent) {
    return /*#__PURE__*/_jsx(IntroComponent, {
      type: type,
      appName: appName
    });
  } else if (type === 'OAuth' || type === 'OAuthWithPolling') {
    return /*#__PURE__*/_jsx(FormattedHTMLMessage, {
      "data-test-id": "oauth-intro",
      message: "unifiedAuthCore.auth.connectDefaultOAuthIntro",
      options: {
        appName
      }
    });
  }
  return null;
}